import { Outlet } from "react-router-dom";
import { MainNav } from "@/components/MainNav";
export function PublicLayout() {
  return <div className="min-h-screen flex flex-col w-full font-inter">
      <MainNav />
      <main className="bg-background flex-1 pt-20">
        <Outlet />
      </main>
    </div>;
}